import { Tier } from '@app/shared/enums';

export class CheckSiteTierComplianceApiModel {
  public SiteId: number;
  public SiteTier: Tier;
}
